document.addEventListener('click', function(e) {
    const btn = e.target.closest('.size-options .size button');
    if (!btn) return;

    if (btn.disabled || btn.classList.contains('is--adding') || btn.classList.contains('is--added')) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent.trim();

    btn.classList.add('is--adding');
    btn.setAttribute('aria-label', 'Adding to cart...');
    btn.textContent = '...';

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
    })
        .then(res => {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
        })
        .then(() => {
            btn.classList.remove('is--adding');
            btn.classList.add('is--added');
            btn.textContent = '✓';
            btn.setAttribute('aria-label', `${originalText} added to cart`);

            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

            setTimeout(() => {
                btn.classList.remove('is--added');
                btn.textContent = originalText;
                btn.setAttribute('aria-label', `Add ${originalText} to cart`);
            }, 1500);
        })
        .catch(() => {
            btn.classList.remove('is--adding');
            btn.textContent = originalText;
            btn.setAttribute('aria-label', `Add ${originalText} to cart`);
            alert('Could not add to cart. Please try again.');
        });
});